import { Col, Row } from "react-bootstrap"


export const Row_ = (r) => {
    return (
        <Row>
            {r.children}
        </Row>
    )
}

export const Col_ = (r) => {
    return (
        <Col sm={r.sm} >
            {r.children}
        </Col>

    )
}


export default function getQuery(route) {

    const queryString = window.location.search;
    const params = queryString.slice(1).split('&');
    for (let i = 0; i < params.length; i++) {
        const [key, value] = params[i].split('=');
        if (key === route) {
            return decodeURIComponent(value);
        }
    }
    return null;
}